import React, { useState, useEffect, useRef } from 'react';
import {
    Form, FormGroup, Label, Input, Button,
    Card, CardHeader, CardBody,
    Table, Badge,
    InputGroup, InputGroupText,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
    Tooltip,
    Modal,
    ModalFooter,
    ModalBody,
    ModalHeader
} from 'reactstrap';
import { FiSearch, FiXCircle, FiCheckCircle, FiChevronDown, FiInfo } from 'react-icons/fi';
import { FaTelegramPlane, FaTrash,FaEdit } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { AdminService } from 'services/AdminService';
import { User } from 'models/User';
import Breadcrumb from "components/Common/Breadcrumb";
import { useAuth } from "context/AuthProvider";
import AdminTableContainer from "admin/dispatch/AdminTableContainer";
import { toast } from 'react-toastify';
interface Customer {
    id: string;
    name: string;
    email: string;
    customerId: string;
}

interface BroadcastMessage {
    _id: string;
    message: string;
    sentTo: string;
    date: string;
    status: 'Active' | 'Inactive';
    customerIds: string[];
    customerDetails: CustomerDetail[];
}

interface ApiResponse<T> {
    success: boolean;
    message: string;
    data?: T;
}

interface PromoCode {
    _id: string;
    code: string;
    discountPercent: number;
    status: 'Active' | 'Inactive';
    created_at: string;
    totalQuantity?: number;     
    perAccountLimit?: number;
     keepLimit?: boolean;    
 
}
interface CustomerDetail {

    lastName: string,
    firstName: string;

}

interface PromoCodeLimits {
    totalUsageLimit?: number;
    perAccountLimit?: number;
    keepLimit?: boolean;
}

interface EditPromoData {
    _id: string;
    code: string;
    discountPercent: number;
    status: 'Active' | 'Inactive';
    totalQuantity?: number;
    perAccountLimit?: number;
    // keepLimit?: boolean;
}
interface PromoSettings {
  promosEnabled: boolean;
}


const Broadcast: React.FC = () => {
    const [selectedCustomers, setSelectedCustomers] = useState<Customer[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [message, setMessage] = useState('');
    const [broadcasts, setBroadcasts] = useState<BroadcastMessage[]>([]);
    const [filter, setFilter] = useState<'all' | 'active' | 'individual' | 'all_customers'>('all');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const maxChar = 250;
    const searchRef = useRef<HTMLInputElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [customerDropdownOpen, setCustomerDropdownOpen] = useState(false);
    const [statusDropdownOpen, setStatusDropdownOpen] = useState<string | null>(null);
    const [user] = useAuth();
    const [activeTab, setActiveTab] = useState<'broadcast' | 'promo'>('broadcast');
    const [promoCodes, setPromoCodes] = useState<PromoCode[]>([]);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editPromoData, setEditPromoData] = useState<EditPromoData | null>(null);
    const [isPromoSectionActive, setIsPromoSectionActive] = useState(false);
    const [loadingPromoStatus, setLoadingPromoStatus] = useState(false);
    const [newPromo, setNewPromo] = useState({
        code: '',
        discountPercent: 5
    });
    const getAllCustomers = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await AdminService.getBroadcastCustomerList();
            console.log("%%%%%%%", res)
            if (res.success && res.data) {
                const mappedCustomers = res.data.userList.map((user: User) => ({
                    id: user._id || '',
                    name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
                    email: user.email || '',
                    customerId: user.customerId || ''
                })).filter((customer: { id: any; }) => customer.id);

                setCustomers(mappedCustomers);
            } else {
                setError(res.message || 'Failed to fetch customers');
            }
        } catch (err) {
            setError('An error occurred while fetching customers');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllCustomers();
    }, []);

    const fetchAllBroadcasts = async () => {
        try {
            if (!user?._id) return;
            const res = await AdminService.getBroadcastMessages(user._id);
            console.log("res data", res.data)
            if (res.success && res.data) {
                const data = Array.isArray(res.data) ? res.data : [res.data];
                const formattedBroadcasts = data.map(b => ({
                    ...b,
                    id: b._id || b.id
                }));
                setBroadcasts(formattedBroadcasts);
            }
        } catch (err) {
            console.error("Error fetching broadcasts:", err);
        }
    };

    useEffect(() => {
        fetchAllBroadcasts();
    }, [user?._id]);
    useEffect(() => {
        if (activeTab === 'promo') {
            fetchPromoCodes();
            fetchPromoStatus();
        }
    }, [activeTab]);
    useEffect(() => {
        if (activeTab === 'broadcast') {
            fetchAllBroadcasts();
        }
    }, [activeTab]);

    const fetchPromoStatus = async () => {
            setLoadingPromoStatus(true);
               try {
                 const res = await AdminService.getPromoStatus();
                 console.log("setting",res)
                 if (res.success && typeof res.data?.data?.enabled === 'boolean') {
                  setIsPromoSectionActive(res.data.data.enabled);
                 }
                } catch (error) {
             console.error("Error fetching promo status:", error);
                 } finally {
               setLoadingPromoStatus(false);
              }
           };

         const togglePromoSection = async (enabled: boolean) => {
           // Ask for confirmation first
            const result = await Swal.fire({
                 title: `Are you sure you want to ${enabled ? 'enable' : 'disable'} the promo section?`,
                 icon: 'warning',
                 showCancelButton: true,
                 confirmButtonText: 'Yes',
                 cancelButtonText: 'No',
            });

             if (!result.isConfirmed) {
             return; // user cancelled
           }

       try {
           setLoadingPromoStatus(true);
           const res = await AdminService.togglePromotions(enabled);
           console.log("467", res);

            if (res.success) {
            setIsPromoSectionActive(enabled);
            Swal.fire({
            title: `Promo section ${enabled ? 'enabled' : 'disabled'}!`,
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
           });
   
           } else {
              Swal.fire({
               title: 'Error',
               text: res.message || 'Failed to update promo section status',
               icon: 'error'
            });
          }
        } catch (error) {
          console.error("Error toggling promo section:", error);
          Swal.fire({
          title: 'Error',
          text: 'Failed to update promo section status',
          icon: 'error'
         });
         } finally {
          setLoadingPromoStatus(false);
         }
       };
    const filteredCustomers = customers.filter(
        customer =>
            !selectedCustomers.some(c => c.id === customer.id) &&
            (
                customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.customerId.toLowerCase().includes(searchTerm.toLowerCase())
            )
    );

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
                searchRef.current && !searchRef.current.contains(event.target as Node)) {
                setCustomerDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelectCustomer = (customer: Customer) => {
        setSelectedCustomers([...selectedCustomers, customer]);
        setSearchTerm('');
        setCustomerDropdownOpen(false);
    };

    const handleSelectAll = () => {
        if (selectedCustomers.length === customers.length) {
            setSelectedCustomers([]);
        } else {
            setSelectedCustomers([]);
        }
        setCustomerDropdownOpen(false);
    };

    const handleRemoveCustomer = (customerId: string) => {
        setSelectedCustomers(selectedCustomers.filter(c => c.id !== customerId));
    };

    const handleSend = async () => {
        if (!message.trim() || (selectedCustomers.length === 0 && customers.length === 0)) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to send this broadcast message?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send it!'
        });

        if (result.isConfirmed) {
            try {
                const sentTo = selectedCustomers.length === 0
                    ? 'All Customers'
                    : `${selectedCustomers.length} Customer${selectedCustomers.length > 1 ? 's' : ''}`;

                const newBroadcast: Omit<BroadcastMessage, 'id'> = {
                    message,
                    sentTo,
                    date: new Date().toISOString(),
                    status: 'Active',
                    customerIds: selectedCustomers.map(c => c.id),
                    _id: '',
                    customerDetails: []
                };

                const response = await AdminService.createBroadCastMessage(newBroadcast) as unknown as ApiResponse<BroadcastMessage>;

                if (response.success && response.data) {
                    fetchAllBroadcasts()
                    setBroadcasts(prev => [{
                        ...response.data!,
                        id: response.data!._id || response.data!._id
                    }, ...prev]);
                    setMessage('');
                    setSelectedCustomers([]);

                    Swal.fire({
                        title: 'Sent!',
                        text: response.message,
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to send broadcast message.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        }
    };

    const handleRemoveBroadcast = async (id: string) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to remove this broadcast message?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await AdminService.deleteBroadCastMessage(id);
                if (response.success) {
                    setBroadcasts(prev => prev.filter(b => b._id !== id));
                    Swal.fire({
                        title: 'Removed!',
                        text: response.message,
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.message || 'Failed to remove broadcast message.',
                        icon: 'error',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            } catch (error) {
                console.error("Error removing broadcast:", error);
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to remove broadcast message.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        }
    };

    const filteredBroadcasts = broadcasts.filter(broadcast => {
        if (filter === 'active') return broadcast.status === 'Active';
        if (filter === 'individual') return !broadcast.sentTo.includes('All Customers');
        if (filter === 'all_customers') return broadcast.sentTo.includes('All Customers');
        return true;
    });

    const toggleCustomerDropdown = () => setCustomerDropdownOpen(!customerDropdownOpen);

    const toggleStatusDropdown = (id: string) => {
        setStatusDropdownOpen(prev => prev === id ? null : id);
    };

    const handleStatusChange = async (id: string, newStatus: 'Active' | 'Inactive') => {
        try {
            const response = await AdminService.updateBroadcastStatus(id, newStatus);
            if (response.success) {
                setBroadcasts(prev => prev.map(b =>
                    b._id === id ? { ...b, status: newStatus } : b
                ));
                setStatusDropdownOpen(null);
                Swal.fire({
                    title: 'Updated!',
                    text: 'Status changed successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to update status',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false
            });
        }
    };

    const createPromoCode = async () => {
        if (!newPromo.code.trim() || newPromo.discountPercent <= 0) {
            Swal.fire({
                title: 'Error!',
                text: 'Please enter a valid promo code and discount percentage',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }

        try {
            console.log("*************", newPromo)
            const response = await AdminService.createPromoCode(newPromo);
            console.log("Res", response)
            if (response.success && response.data) {
                setPromoCodes(prev => [response.data, ...prev]);
                setNewPromo({ code: '', discountPercent: 10 });
                Swal.fire({
                    title: 'Success!',
                    text: 'Promo code created successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to create promo code',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false
            });
        }
    };
    const fetchPromoCodes = async () => {
        setLoading(true);
        setError('');
        try {
            if (!user?._id) return;
            const res = await AdminService.getPromoCode(user._id);
            console.log("prmo",res)
            if (res.success && res.data) {
                console.log("promo",res.data)
                setPromoCodes(Array.isArray(res.data) ? res.data : [res.data]);
            } else {
                setError(res.message || 'Failed to fetch promo codes');
            }
        } catch (err) {
            setError('An error occurred while fetching promo codes');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const updatePromoStatus = async (id: string, status: 'Active' | 'Inactive') => {
        try {
            const response = await AdminService.updatePromoCodeStatus(id, status);
            if (response.success) {
                setPromoCodes(prev => prev.map(p =>
                    p._id === id ? { ...p, status } : p
                ));
                setStatusDropdownOpen(null);
                Swal.fire({
                    title: 'Updated!',
                    text: 'Promo status changed successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to update promo status',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false
            });
        }
    };

    const deletePromoCode = async (id: string) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this promo code?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await AdminService.deletePromoCode(id);
                if (response.success) {
                    setPromoCodes(prev => prev.filter(p => p._id !== id));
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Promo code deleted successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to delete promo code',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        }
    };

    // const toggleStatusDropdown = (id: string) => {
    //     setStatusDropdownOpen(prev => prev === id ? null : id);
    // };



    const broadcastColumns = React.useMemo(
        () => [
            {
                Header: 'Message',
                accessor: 'message',
                disableFilters: true,
            },        
               {
                Header: 'Sent To',
                accessor: 'row',
                disableFilters: true,
                Cell: ({ row }: { row: { original: BroadcastMessage } }) => {
                    const { customerDetails } = row.original;
                    const [expanded, setExpanded] = useState(false);
            
                    if (!customerDetails || customerDetails.length === 0) {
                        return 'All';
                    }
            
                    const names = customerDetails.map(customer => 
                        `${customer.firstName} ${customer.lastName}`
                    );
            
                    if (names.length <= 10) {
                        return (
                            <div>
                                {names.join(', ')}
                            </div>
                        );
                    }
            
                    return (
                        <div>
                            {expanded ? names.join(', ') : `${names.slice(0, 10).join(', ')}...`}
                            <span 
                                style={{ 
                                    color: '#1890ff', 
                                    cursor: 'pointer',
                                    marginLeft: '4px'
                                }}
                                onClick={() => setExpanded(!expanded)}
                            >
                                {expanded ? '(show less)' : `(+${names.length - 10} more)`}
                            </span>
                        </div>
                    );
                }
            },     
            {
                Header: 'Date',
                accessor: 'date',
                Cell: ({ value }: { value: string }) => (
                    new Date(value).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })
                ),
                disableFilters: true,
            },

            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ row }: { row: any }) => {
                    const broadcast = row.original;
                    const status = broadcast.status;

                    // Determine badge class
                    const getBadgeClass = (status: string) => {
                        switch (status) {

                            case 'Active':
                                return 'bg-success text-white ';
                            case 'Inactive':
                                return 'bg-secondary text-white';
                            default:
                                return 'bg-dark text-white';
                        }
                    };

                    return (
                        <Dropdown
                            isOpen={statusDropdownOpen === broadcast._id}
                            toggle={() => toggleStatusDropdown(broadcast._id)}
                        >
                            <DropdownToggle
                                caret
                                className={`badge rounded-pill d-inline-block text-center px-3 py-1 fw-semibold text-xs ${getBadgeClass(status)}`}
                                style={{ minWidth: "80px", fontSize: "0.75rem", outline: "none", boxShadow: "none" }}
                            >
                                {status}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => handleStatusChange(broadcast._id, 'Active')}>
                                    Active
                                </DropdownItem>
                                <DropdownItem onClick={() => handleStatusChange(broadcast._id, 'Inactive')}>
                                    Inactive
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    );
                },
                disableFilters: true,
            }
            ,
            {
                Header: 'Action',
                accessor: 'action',
                Cell: ({ row }: { row: any }) => {
                    const broadcast = row.original;
                    return (
                        <div className="text-center">
                            <Button


                                onClick={() => void handleRemoveBroadcast(broadcast._id)}
                                className="btn btn-sm"
                                style={{
                                    backgroundColor: "#ff875a",
                                    color: "#fff",
                                    fontWeight: 500,
                                    padding: "3px 10px",
                                    fontSize: "0.75rem",
                                    borderRadius: "4px",
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    );
                },
                disableFilters: true,
            },
        ],
        [statusDropdownOpen]
    );

    const promoColumns = React.useMemo(
        () => [
            {
                Header: 'Code',
                accessor: 'code',
                disableFilters: true,
            },
            {
                Header: 'Discount %',
                accessor: 'discountPercent',
                Cell: ({ value }: { value: number }) => `${value}%`,
                disableFilters: true,
            },
             {
                Header: 'Used Count',
                accessor: 'usedCount',
                disableFilters: true,
            },
          {
               Header: 'Total usage limit',
               accessor: 'totalQuantity',
               disableFilters: true,
               Cell: ({ value }) => value ? value : 'No limit set'
           },
           {
               Header: 'Individual usage limit',
               accessor: 'perAccountLimit',
               disableFilters: true,
               Cell: ({ value }) => value ? value : 'No limit set'
           }
           ,
            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ row }: { row: any }) => {
                    const promo = row.original;
                    return (
                        <Dropdown
                            isOpen={statusDropdownOpen === promo._id}
                            toggle={() => toggleStatusDropdown(promo._id)}
                        >
                            <DropdownToggle
                                caret
                                className={`badge rounded-pill d-inline-block text-center px-3 py-1 fw-semibold text-xs ${promo.status === 'Active' ? 'bg-success' : 'bg-secondary'
                                    } text-white`}
                                style={{ minWidth: "80px", fontSize: "0.75rem" }}
                            >
                                {promo.status}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => updatePromoStatus(promo._id, 'Active')}>
                                    Active
                                </DropdownItem>
                                <DropdownItem onClick={() => updatePromoStatus(promo._id, 'Inactive')}>
                                    Inactive
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    );
                },
                disableFilters: true,
            },
            {
                Header: 'Created Date',
                accessor: 'createdAt',
                Cell: ({ value }: { value: string }) => (
                    new Date(value).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })
                ),
                disableFilters: true,
            },
         
            {
               Header: 'Action',
               accessor: 'action',
               Cell: ({ row }: { row: any }) => {
                   const promo = row.original;
                   return (
                       <div className="flex justify-center gap-2">
                           {/* Edit Button */}
                        <i
                         className="bx bx-edit text-secondary fs-5"
                         role="button"
                         title="Edit"
                           onClick={() => handleEditClick(promo)}
                       ></i>
           
                        <i
                          className="bx bx-trash text-danger fs-5"
                          role="button"
                          onClick={() => deletePromoCode(promo._id)}
                        ></i>
                         </div>
                     );}
                 },
                     ],
                     [statusDropdownOpen]
                 );

    // Format the data for AdminTableContainer
    const formattedBroadcasts = filteredBroadcasts.map(broadcast => ({
        ...broadcast,
        id: broadcast._id,
    }));


    const handleEditClick = (promo: PromoCode) => {
         console.log('Editing promo:', promo);
    setEditPromoData({
        _id: promo._id,
        code: promo.code,
        discountPercent: promo.discountPercent,
        status: promo.status,
        totalQuantity: promo.totalQuantity,
        perAccountLimit: promo.perAccountLimit,
        // keepLimit: promo.keepLimit || false
    });
    setEditModalOpen(true);
};

// Add this function to handle promo update
const handleUpdatePromo = async () => {
    if (!editPromoData) return;
    
    try {
const res = await AdminService.updatePromoLimits(
      editPromoData._id,
      {
      
        totalQuantity: editPromoData.totalQuantity,
        perAccountLimit: editPromoData.perAccountLimit,
        // keepLimit: editPromoData.keepLimit || false
      }
    );
    console.log("dddd",res)

        if (res.success) {
            setPromoCodes(prev => prev.map(p => 
                p._id === editPromoData._id ? { 
                    ...p, 
                    totalQuantity: editPromoData.totalQuantity,
                    perAccountLimit: editPromoData.perAccountLimit,
                    // keepLimit: editPromoData.keepLimit
                    
                } : p
            ));
            setEditModalOpen(false);
            toast.success("Promo code updated successfully",{
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: "foo-bar",
                        style: { marginBottom: "4rem" },
                      });
        
        
        }else{
            {
            return toast.error("update failed", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: "foo-bar",
                        style: { marginBottom: "4rem" },
                      });
                    }
        }
    } catch (error) {
        Swal.fire({
            title: 'Error!',
            text: 'Failed to update promo code',
            icon: 'error',
            timer: 2000,
            showConfirmButton: false
        });
    }
};


    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumb title="Broadcast" breadcrumbItem="Create" />

                <Nav tabs className="mb-4">
                    <NavItem>
                        <NavLink
                            active={activeTab === 'broadcast'}
                            onClick={() => setActiveTab('broadcast')}
                            style={{ cursor: 'pointer' }}
                        >
                            Broadcast
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            active={activeTab === 'promo'}
                            onClick={() => setActiveTab('promo')}
                            style={{ cursor: 'pointer' }}
                        >
                            Promo Codes
                        </NavLink>
                    </NavItem>
                </Nav>
              
                 <Modal
                     isOpen={editModalOpen}
                     toggle={() => setEditModalOpen(false)}
                     size="lg"
                    style={{ maxWidth: '1000px' }}
                     contentClassName="custom-modal-content"
                   >
                            <ModalHeader toggle={() => setEditModalOpen(false)}>
                              Edit Promo Code
                            </ModalHeader>
                            <ModalBody>
                              <div className="px-5 py-2">
                                <Form>
                                  <Row>
                                    <Col md={6}>
                                      <FormGroup>
                                        <Label>Promo Code</Label>
                                        <Input
                                          type="text"
                                          value={editPromoData?.code || ''}
                                            readOnly 
                                        />
                                      </FormGroup>
                                      </Col>
                                      <Col md={6}>
                                        <FormGroup>
                                          <Label>Discount Percentage</Label>
                                          <Input
                                            type="number"
                                            min="1"
                                            max="100"
                                              readOnly 
                                            value={editPromoData?.discountPercent || 0}
                                        
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
        
                                  
                                     
                                     <h5 className="mb-4">Usage Limits</h5>
                                     
                                    <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Total Usage Limit</Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                placeholder="No limit if empty"
                                                value={editPromoData?.totalQuantity || ''}
                                                onChange={(e) => setEditPromoData({
                                                    ...editPromoData!,
                                                    totalQuantity: e.target.value ? parseInt(e.target.value) : undefined
                                                })}
                                            />
                                            <small className="text-muted">Maximum times this promo can be used in total</small>
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Per Account Limit</Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                placeholder="No limit if empty"
                                                value={editPromoData?.perAccountLimit || ''}
                                                onChange={(e) => setEditPromoData({
                                                    ...editPromoData!,
                                                    perAccountLimit: e.target.value ? parseInt(e.target.value) : undefined
                                                })}
                                            />
                                            <small className="text-muted">Maximum times a single account can use this promo</small>
                                        </FormGroup>
                                    </Col>
                                         </Row>
                                            {/* <FormGroup check>
                                             <Input
                                                 type="checkbox"
                                                  checked={!!editPromoData?.keepLimit}
                                                 onChange={(e) => setEditPromoData({
                                                     ...editPromoData!,
                                                     keepLimit: e.target.checked
                                                 })}
                                             />
                                           <Label check>
                                          Keep existing usage counts 
                                           </Label>

                                         </FormGroup> */}
                                     
                                     <hr className="my-4" />
                                     
                                   </Form>
                                 </div>
                               </ModalBody>
                               <ModalFooter>
                                 <Button 
                                   color="secondary" 
                                   onClick={() => setEditModalOpen(false)}
                                   className="px-4"
                                 >
                                   Cancel
                                 </Button>
                                 <Button 
                                   color="primary" 
                                 onClick={handleUpdatePromo}
                                   className="px-4"
                                 >
                                   Save Changes
                                 </Button>
                               </ModalFooter>
                 </Modal>
                
                {activeTab === 'broadcast' ? (
                    <>
                        <Card className="mb-4">
                            <CardBody>
                                {error && <div className="alert alert-danger">{error}</div>}
                                {loading && <div className="text-center py-4">Loading customers...</div>}

                                <FormGroup>
                                    <Label>Recipients</Label>
                                    <div className="position-relative" ref={dropdownRef}>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FiSearch />
                                            </InputGroupText>
                                            <Input
                                                innerRef={searchRef}
                                                type="text"
                                                placeholder="Search customers or select 'All Customers'"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setCustomerDropdownOpen(true);
                                                }}
                                                onFocus={() => setCustomerDropdownOpen(true)}
                                            />
                                            <Button
                                                color="secondary"
                                                outline
                                                onClick={toggleCustomerDropdown}
                                            >
                                                <FiChevronDown />
                                            </Button>
                                        </InputGroup>

                                        <Dropdown isOpen={customerDropdownOpen} toggle={toggleCustomerDropdown}>
                                            <DropdownMenu className="w-100 mt-1" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                <DropdownItem
                                                    key="all"
                                                    active={selectedCustomers.length === 0}
                                                    onClick={handleSelectAll}
                                                    className="d-flex align-items-center"
                                                >
                                                    <FiCheckCircle className="me-2" />
                                                    <span>All Customers</span>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                {filteredCustomers.length > 0 ? (
                                                    filteredCustomers.map((customer) => (
                                                        <DropdownItem
                                                            key={customer.id}
                                                            onClick={() => handleSelectCustomer(customer)}
                                                            className="d-flex align-items-center"
                                                        >
                                                            <div>
                                                                <div>{customer.customerId}</div>
                                                                <small className="text-muted">{customer.email}</small>
                                                            </div>
                                                        </DropdownItem>
                                                    ))
                                                ) : (
                                                    <DropdownItem disabled>No customers found</DropdownItem>
                                                )}
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>

                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                        {selectedCustomers.length === 0 ? (
                                            <Badge color="primary" className="d-flex align-items-center">
                                                All Customers
                                                <FiXCircle
                                                    className="ms-2 cursor-pointer"
                                                    size={14}
                                                    onClick={() => setSelectedCustomers([])}
                                                />
                                            </Badge>
                                        ) : (
                                            selectedCustomers.map((customer) => (
                                                <Badge key={customer.id} color="primary" className="d-flex align-items-center">
                                                    {customer.customerId}
                                                    <FiXCircle
                                                        className="ms-2 cursor-pointer"
                                                        size={14}
                                                        onClick={() => handleRemoveCustomer(customer.id)}
                                                    />
                                                </Badge>
                                            ))
                                        )}
                                    </div>
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label>Message</Label>
                                    <Input
                                        type="textarea"
                                        rows={5}
                                        maxLength={maxChar}
                                        placeholder="E.g. Your bill is past due, please make a payment."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                    <div className="d-flex justify-content-end">
                                        <small className="text-muted">
                                            {message.length}/{maxChar} characters
                                        </small>
                                    </div>
                                </FormGroup>

                                <div className="text-end">
                                    <Button
                                        color="primary"
                                        onClick={() => void handleSend()}
                                        disabled={!message.trim() || (selectedCustomers.length === 0 && customers.length === 0)}
                                    >
                                        <FaTelegramPlane size={20} style={{ marginRight: '8px' }} /> Send Broadcast
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>

                        <Card className="shadow-sm border-0">
                            <CardHeader className="bg-white d-flex justify-content-between align-items-center">
                                <h6 className="mb-0 fw-bold">Broadcasts Messages</h6>
                                <div className="btn-group btn-group-sm">
                                    <Button
                                        color={filter === 'all' ? 'warning' : 'light'}
                                        className={filter === 'all' ? 'text-white' : ''}
                                        onClick={() => setFilter('all')}
                                    >
                                        All
                                    </Button>
                                    <Button
                                        color={filter === 'active' ? 'primary' : 'light'}
                                        className={filter === 'active' ? 'text-white' : ''}
                                        onClick={() => setFilter('active')}
                                    >
                                        Active
                                    </Button>
                                    <Button
                                        color={filter === 'individual' ? 'info' : 'light'}
                                        className={filter === 'individual' ? 'text-white' : ''}
                                        onClick={() => setFilter('individual')}
                                    >
                                        Individual
                                    </Button>
                                    <Button
                                        color={filter === 'all_customers' ? 'success' : 'light'}
                                        className={filter === 'all_customers' ? 'text-white' : ''}
                                        onClick={() => setFilter('all_customers')}
                                    >
                                        All Customers
                                    </Button>
                                </div>
                            </CardHeader>


                            <CardBody>
                                {filteredBroadcasts.length === 0 ? (
                                    <div className="text-center py-4 text-muted">
                                        No broadcast messages found.
                                    </div>
                                ) : (
                                    <AdminTableContainer
                                        columns={broadcastColumns}
                                        data={formattedBroadcasts}
                                        pagelimit={1}
                                        handlePageChange={() => { }}
                                        handleSearch={false}
                                        handleColumnChange={() => { }}
                                        selectedColumns={10}
                                        showColumnChange={false}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        isJobListGlobalFilter={false}
                                        isChangeDateList={false}
                                        isChangeDriverList={false}
                                        isModified={false}
                                        setIsModified={() => { }}
                                        isPDFGenerate={false}
                                        ispopup={false}
                                        isAddressBook={false}
                                        hancleDeleteRecords={undefined}
                                        handleSelect={undefined}
                                        selectedID={undefined}
                                        getChangedStatusData={undefined}
                                        currentStatus={""}
                                        isChangeMultipleStatus={false}

                                    />
                                )}
                            </CardBody>
                        </Card>
                    </>
                ) : (
                    <>
                 
                        {/* <form autoComplete="off" onSubmit={createPromoCode}>
                            <Row>
                                <Col lg={12}>
                                    <Card>
                                        <CardBody>
                                            <div className="wizard clearfix">
                                                <div className="content clearfix">
                                                    <Row>
                                                        <Col lg="5">
                                                            <div className="mb-3 form-group">
                                                                <Label>Promo Code</Label>
                                                                <Input
                                                                    type="text"
                                                                    placeholder="e.g., ZULU20"
                                                                    maxLength={10}
                                                                    value={newPromo.code}
                                                                    onChange={(e) =>
                                                                        setNewPromo({
                                                                            ...newPromo,
                                                                            code: e.target.value
                                                                                .toUpperCase()
                                                                                .replace(/[^A-Z0-9]/g, ''),
                                                                        })
                                                                    }
                                                                /></div>
                                                        </Col>
                                                        <Col lg="4">
                                                            <div className="mb-3 form-group">
                                                                <Label>Discount %</Label>
                                                                <Input
                                                                    type="number"
                                                                    min="1"
                                                                    max="100"
                                                                    value={newPromo.discountPercent}
                                                                    onChange={(e) =>
                                                                        setNewPromo({
                                                                            ...newPromo,
                                                                            discountPercent: parseInt(e.target.value) || 0,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg="2">
                                                            <div className="mb-3 form-group">
                                                                <Label style={{ visibility: 'hidden' }}>Button</Label>
                                                                <Button
                                                                    color="primary"
                                                                    className="w-100"
                                                                    onClick={createPromoCode}
                                                                    disabled={
                                                                        !newPromo.code.trim() ||
                                                                        newPromo.discountPercent <= 0
                                                                    }
                                                                >
                                                                    Create
                                                                </Button>
                                                            </div>
                                                        </Col>



                                                    </Row>


                                                </div>

                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </form> */}

                         <Row>

                     <Col lg={8}>
                        <Card>
      
                         <CardBody>
                              <h6 className="mb-4 fw-bold">Create New Promo Code</h6>
                           <form autoComplete="off" onSubmit={createPromoCode}>
                             <Row>
                               <Col lg="6">
                                 <div className="mb-3 form-group">
                                   <Label>Promo Code</Label>
                                   <Input
                                     type="text"
                                     placeholder="e.g., ZULU20"
                                     maxLength={10}
                                     value={newPromo.code}
                                     onChange={(e) =>
                                       setNewPromo({
                                         ...newPromo,
                                         code: e.target.value
                                           .toUpperCase()
                                           .replace(/[^A-Z0-9]/g, ''),
                                       })
                                     }
                                   />
                                 </div>
                               </Col>
                               <Col lg="4">
                                 <div className="mb-3 form-group">
                                   <Label>Discount %</Label>
                                   <Input
                                     type="number"
                                     min="1"
                                     max="100"
                                     value={newPromo.discountPercent}
                                     onChange={(e) =>
                                       setNewPromo({
                                         ...newPromo,
                                         discountPercent: parseInt(e.target.value) || 0,
                                       })
                                     }
                                   />
                                 </div>
                               </Col>
                               <Col lg="2">
                                 <div className="mb-3 form-group">
                                   <Label style={{ visibility: 'hidden' }}>Button</Label>
                                   <Button
                                     color="primary"
                                     className="w-100"
                                     onClick={createPromoCode}
                                     disabled={
                                       !newPromo.code.trim() ||
                                       newPromo.discountPercent <= 0
                                     }
                                   >
                                     Create
                                   </Button>
                                 </div>
                               </Col>
                             </Row>
                           </form>
                         </CardBody>
                  </Card>
                 </Col>

                     <Col lg={4}>
                       <Card>
                         
                         <CardBody>
                               <h6 className="mb-4 fw-bold">Promo Section Status</h6>
                           <div className="d-flex flex-column">
                             <p className="text-muted small mb-3">
                   Use this switch to enable or disable the entire promo section. 
                   When turned **OFF**, users will not see or be able to enter any promo codes 
                   in the portal or the app. When **ON**, all active promo codes will be available.
                 </p>
                             <div className="d-flex align-items-center justify-content-between mt-2">
                               <Label className="mb-0 fw-medium">Promo Section:</Label>
                          <FormGroup switch className="mb-0 ms-3 d-flex align-items-center">
                   <Input
                     type="switch"
                     checked={isPromoSectionActive}
                     onChange={(e) => togglePromoSection(e.target.checked)}
                     className="ms-auto"
                     disabled={loadingPromoStatus}
                   />
                   
                   <span className="ms-2 ">
                     {isPromoSectionActive ? 'ON' : 'OFF'}
                   </span>
                 
                   {loadingPromoStatus && (
                     <div className="spinner-border spinner-border-sm ms-2" role="status">
                       <span className="visually-hidden">Loading...</span>
                     </div>
                   )}
                 </FormGroup>
                 
                             </div>
                           
                           </div>
                         </CardBody>
                       </Card>
                     </Col>
                   </Row>

                        <Card className="shadow-sm border-0">
                            <CardHeader className="bg-white">
                                <h6 className="mb-0 fw-bold">Active Promo Codes</h6>
                            </CardHeader>
                            <CardBody>
                                {promoCodes.length === 0 ? (
                                    <div className="text-center py-4 text-muted">
                                        No promo codes found. Create your first promo code above.
                                    </div>
                                ) : (
                                    <AdminTableContainer
                                        columns={promoColumns}
                                        data={promoCodes}
                                        pagelimit={1}
                                        handlePageChange={() => { }}
                                        handleSearch={false}
                                        handleColumnChange={() => { }}
                                        selectedColumns={10}
                                        showColumnChange={false}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        isJobListGlobalFilter={false}
                                        isChangeDateList={false}
                                        isChangeDriverList={false}
                                        isModified={false}
                                        setIsModified={() => { }}
                                        isPDFGenerate={false}
                                        ispopup={false}
                                        isAddressBook={false}
                                        hancleDeleteRecords={undefined}
                                        handleSelect={undefined}
                                        selectedID={undefined}
                                        getChangedStatusData={undefined}
                                        currentStatus={""}
                                        isChangeMultipleStatus={false}
                                    />
                                )}
                            </CardBody>
                        </Card>







                    </>)}
            </div>
        </div>
    );
};

export default Broadcast; 